var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"superadmin-page"},[_c('BackTitle',{staticClass:"mb-32",attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" Create venue ")]),_c('VenueForm',{attrs:{"value":_vm.venue,"submitButtonText":"Register","isSubmitting":_vm.isSubmitting,"isIdEditable":true},on:{"submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }